import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/app/demo-home/page.tsx")